import React from "react";
import classNames from "classnames";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { ListToggleArrow } from "@common/listToggleArrow";
import { ResourceAvatar } from "@common/resourceAvatar";
import { resource } from "@planzone/dto";
import { Safeguard } from "@scenes/safeguard";
import { Cell } from "./cell";
import { ProjectsDetail } from "../projectsDetail";
import { Props } from "./types";
import styles from "./styles.scss";

function Row(props: Props) {
  const { pushView } = useModal();
  const isWeekly = props.granularity === "WEEK";

  return (
    <Safeguard useCases={[UseCases.retrieveResource]}>
      {({ canRetrieveResource }) => (
        <React.Fragment>
          <div
            className={classNames(styles.resourceRow, {
              [styles.withMonthRow]: isWeekly,
            })}
          >
            <div className={styles.resourceCell}>
              <div
                className={classNames(styles.chevronBox, styles.clickable)}
                onClick={props.toggle}
              >
                <ListToggleArrow isOpen={props.isExpanded} />
              </div>
              <div
                className={classNames(styles.identityGroup, {
                  [styles.clickable]: canRetrieveResource,
                })}
                onClick={() =>
                  canRetrieveResource &&
                  pushView({
                    key: UseCases.retrieveResource,
                    data: props.resource.uuid,
                  })
                }
              >
                <div className={styles.avatar}>
                  <ResourceAvatar
                    resource={{ ...resource, ...props.resource }}
                  />
                </div>
                <div className={styles.identity}>
                  <p className={styles.name}>{props.resource.name}</p>
                  <p className={styles.profession}>
                    {props.resource.profession}
                  </p>
                </div>
              </div>
            </div>
            {props.resource.periods.map((period, index) => (
              <Cell key={index} period={period} locale={props.locale} />
            ))}
          </div>
          {props.isExpanded && (
            <ProjectsDetail
              resourceId={props.resource.uuid}
              from={props.from}
              to={props.to}
              granularity={props.granularity}
              sort={props.sort}
              filter={props.filter}
              locale={props.locale}
              periodsCount={props.resource.periods.length}
            />
          )}
        </React.Fragment>
      )}
    </Safeguard>
  );
}

export { Row };
